import { UATConstants } from 'src/Common/Models/UATConstants';
import { ITenantUIConfig, TenantProvider } from 'src/tenantConfig/interface/index.ts';
import { GSIFilterConfig } from './filters/GSIFilterConfig';
export const GSITenantConfig: Partial<ITenantUIConfig> = {
  nodeName: [UATConstants.PlaceholdersAndTitles.GSI],
  provider: TenantProvider.ARTEMIS,
  TenantExperience: true,
  FeatureConfig: {
    SensitiveInfoValidation: false,
    SensativeInfoErrorCount: false,
    FieldConfig: GSIFilterConfig,
    AttachmentConfigurations: [],
    Navigation: {
      GlobalSearch: true,
      Copilot: true,
      Analytics: true,
      RequestAccess: true,
      Settings: true,
      Notifications: true,
      Help: true,
    },
    Hub: {
      Filter: true,
      FilterConfig: GSIFilterConfig,
      AreaPath: [UATConstants.GSIAreaPath],
      Title: UATConstants.TenantTitles.GSI,
      ADOTitle: UATConstants.TenantADOText.GSI,
      Create: [
        {
          Text: UATConstants.CreateActionMenuTitle.CreateGSIRequest,
          Key: UATConstants.CreateActionMenuKey.CreateGSIRequest,
          NodeName: '',
        },
      ],
      BulkUpload: false,
      DownloadTemplate: false,
      Download: true,
      Email: true,
      LocalSearch: true,
      ColumnOptions: true,
      ColumnOptionsConfig: [],
      SplitMode: false,
      BulkEdit: false,
      BulkEditConfig: [],
      CreateRAID: false,
      DownloadTemplateConfig: {},
      RelatedItem: true,
    },
    ManageAction: {
      NewExperience: true,
      MandateFormPickers: [
        { formFieldName: 'GSI_ActionOwner', formFieldLabel: UATConstants.PlaceholdersAndTitles.ActionOwner, apiFieldName: 'assignedto' },
        { formFieldName: 'GSI_Requestors', formFieldLabel: UATConstants.PlaceholdersAndTitles.Requestors, apiFieldName: 'requestorsinfo' },
        { formFieldName: 'GSI_CommercialExecutiveCE', formFieldLabel: 'Commercial Executive (CE)', apiFieldName: 'CommercialExecutive' },
        { formFieldName: 'GSI_Approver', formFieldLabel: UATConstants.PlaceholdersAndTitles.Approver, apiFieldName: 'approvedby' },
        { formFieldName: 'GSI_Emails', formFieldLabel: UATConstants.PlaceholdersAndTitles.GSI_Emails, apiFieldName: 'CustomerEmailsToCC' }
      ],
      Header: {
        Tags: true,
        Actions: {
          Follow: true,
          Email: true,
          CopyLink: true,
        },
      },
      Tabs: {
        TechnicalFeedback: false,
        RelatedItems: {
          showRelatedTab: true,
          showTFTCreated: false,
        },
        Attachments: true,
        History: true,
      },
      Panes: {
        CopilotInsights: {
          CustomerInsights: false,
          DiscussionInsights: false,
        },
        StatusUpdate: true,
        ClosureStatement: true,
        Discussion: true,
        Tasks: false,
        EmailConversation: false,
      },
    },
    ManageView: {
      isArtemisIntegrationEnabled: true,
      showAddViewButton: true,
      showAddFolderButton: true,
      showCommandBar: true,
      showPreviewFeatureMessageBar: false,
      showSelectFields: false,
      defaultViewId: '9f37e5c4-5a77-4e01-91aa-9c8aaf7f4f6d',
      systemViewsFolderId: 'fdbd36c5-820e-4102-a0bb-433a7497e4e2',
      sharedViewsFolderId: '8fc280fb-0b81-4d2b-a418-f97aa73f6f59',
    },
  },
};
